import React, { useState } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import AppButton from '../../Components/MerchantButton';
import './UnifiedFormStyles.css';
import { compressAndUpload } from '../../Helpers/Utils/photoUpload';

const SQRPhoto = ({ navigation, primaryDetails, setPrimaryDetails }) => {
  const [error, setError] = useState("");
  const [isUploading, setIsUploading] = useState(false);

  const handleBack = () => {
    navigation.previous();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      setError('Photo exceeds 5MB limit. Please retake the photo.');
      toast.error("Photo exceeds 5MB limit. Please retake the photo.", {
        autoClose: 3000, hideProgressBar: true, theme: "colored"
      });
      e.target.value = '';
      return;
    }

    setIsUploading(true);
    setError('');
    try {
      const uploadResult = await compressAndUpload(file);
      if (!uploadResult.success) {
        setError('Upload failed. Please try again.');
        toast.error(uploadResult.error || "Upload failed. Please try again.");
        e.target.value = '';
        return;
      }
      setPrimaryDetails(prev => ({
        ...prev,
        sqr_photo_temp_path: uploadResult.temp_path
      }));
    } catch (error) {
      toast.error("Error uploading photo");
    } finally {
      setIsUploading(false);
    }
  };

  const handleNext = () => {
    if (!primaryDetails.sqr_photo_temp_path) {
      setError('Photo is required');
      toast.error('Please attach an SQR photo before continuing', { autoClose: 2500, hideProgressBar: true, theme: 'colored' });
      return;
    }
    if (navigation && navigation.go) navigation.go('qrph-door-hanger-merch');
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">SQR Photo</h4>
              <p className="form-desc">Upload a clear photo of the SQR standee/QR.</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Photo of SQR <span className="form-required">*</span>
                      {primaryDetails.sqr_photo_temp_path && !isUploading && (
                        <span style={{ marginLeft: '10px', color: '#28a745' }}>✅ Uploaded</span>
                      )}
                    </Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={handleFileChange}
                      isInvalid={!!error}
                      disabled={isUploading}
                    />
                    {isUploading && <div style={{ color: '#007bff', fontSize: '13px', marginTop: '6px' }}>⏳ Uploading...</div>}
                    {error && <div className="form-error">{error}</div>}
                  </Form.Group>

                  <div className="form-nav-btns">
                    <AppButton onClick={handleBack} variant="back" className="form-btn variant-secondary">
                      ← Back
                    </AppButton>
                    <AppButton onClick={handleNext} variant="next" className="form-btn variant-primary">
                       Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SQRPhoto;

